import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 5,
    seconds: 41
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else {
          return {
            minutes: 0,
            seconds: 0
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (num: number) => num.toString().padStart(2, '0');
  return <div className="fixed top-0 left-0 right-0 bg-red-600 text-white py-3 px-4 z-50 shadow-lg" data-id="element-24">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center flex-wrap" data-id="element-25">
        <ClockIcon className="h-5 w-5 flex-shrink-0 animate-pulse" aria-hidden="true" data-id="element-26" />
        <p className="text-sm md:text-base font-bold" data-id="element-27">
          ATTENTION! The 90% launch discount for 'The Prime Architect' ends in:{' '}
          <span className="inline-block bg-white text-red-600 px-3 py-1 rounded font-mono text-lg mx-2" data-id="element-28">
            {formatTime(timeLeft.minutes)}:{formatTime(timeLeft.seconds)}
          </span>
          <span className="block md:inline mt-1 md:mt-0" data-id="element-29">
            (Only available for the first 100 orders today).
          </span>
        </p>
      </div>
    </div>;
}